<div class="modal-replace-card">
  <img
    src="/assets/icons/blue-info-icon.svg"
    alt="Ícono de información azul"
    class="modal-replace-card__icon"
  />
  <h2 class="modal-replace-card__title">Antes de pagar no olvides</h2>
  <div class="modal-replace-card__content">
    <div class="modal-replace-card__content__row">
      <img
        src="/assets/icons/blue-card-icon.svg"
        alt="Ícono de tarjeta de crédito azul"
        class="bullet-icon"
      />
      <p class="bullet-text">
        Activa tu <span>tarjeta de crédito</span> para compras por internet.
      </p>
    </div>
    <div class="modal-replace-card__content__row" *ngIf="!isPurchaselessOnboarding">
      <img
        src="/assets/icons/blue-limits-icon.svg"
        alt="Ícono de límites azul"
        class="bullet-icon"
      />
      <p class="bullet-text">
        Revisa la línea de tu tarjeta, <span>hoy solo cobraremos la 1ª cuota.</span>
      </p>
    </div>
    <div class="modal-replace-card__content__row">
      <img src="/assets/icons/blue-cvv-icon.svg" alt="Ícono de cvv azul" class="bullet-icon" />
      <p class="bullet-text">
        <span>Si eres cliente de BBVA</span>, obtén el código CVV desde la app de tu banco.
      </p>
    </div>
  </div>
  <div class="modal-replace-card__button">
    <button class="btn-primary-bg" (click)="onCloseModal()">Entendido</button>
  </div>
</div>
